import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    setBusy(true);
    try {
      await register(email, name, password);
      toast.success("Welcome aboard.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-bg min-h-screen flex items-center justify-center p-8" data-testid="register-screen">
      <form onSubmit={onSubmit} className="panel w-[440px] p-8" data-testid="register-form">
        <span className="inline-flex items-center gap-2 mb-4">
          <span className="w-2 h-2 bg-[#00E5FF]"></span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#8B95A5]">QUANTBRIDGE</span>
        </span>
        <h2 className="text-xl font-semibold tracking-tight mb-1">Create account</h2>
        <p className="text-xs text-[#8B95A5] mb-6">Demo / sandbox terminal — no real funds at risk.</p>

        <div className="mb-3">
          <label className="label">Full name</label>
          <input className="field" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
        </div>
        <div className="mb-3">
          <label className="label">Email</label>
          <input type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
        </div>
        <div className="mb-6">
          <label className="label">Password</label>
          <input type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" />
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="register-submit">
          {busy ? "Creating…" : "Create & enter"}
        </button>
        <div className="text-xs text-[#8B95A5] mt-6 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[#00E5FF] hover:underline" data-testid="link-login">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
